/**
 * React binding for the session-held classification correction (`lib/mailVerdictOverride.ts`).
 *
 * `useSyncExternalStore` rather than local state: the badge in the message LIST and the controls in
 * the reader are different components, and correcting a mail in one must redraw the other
 * immediately. Same reason `extractionStore.ts` is a module-level store rather than component state.
 */

import { useSyncExternalStore } from 'react'
import { getOverride, subscribe, type MailVerdictOverride } from '../../lib/mailVerdictOverride'

export function useVerdictOverride(mailId: string): MailVerdictOverride | null {
  return useSyncExternalStore(
    subscribe,
    () => getOverride(mailId),
    () => null,
  )
}
